import { ListItemProps, ListItem as MuiListItem } from "@mui/material";

type Props = ListItemProps;

export const ListItem = ({ children, ...props }: Props) => {
  return <MuiListItem {...props}>{children}</MuiListItem>;
};

export function AnyComponentListItem<C extends React.ElementType>({ children, ...props }: ListItemProps<C, { component?: C }>) {
  return <MuiListItem {...props}>{children}</MuiListItem>;
}
